/**
 * External dependencies
 */

import { __ } from '@wordpress/i18n';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { decodeEntities } from '@wordpress/html-entities';
import { getPaymentMethodData } from '@woocommerce/settings';

/**
 * Internal dependencies
 */
import { PAYMENT_METHOD_NAME } from './constants';
import { useCheckoutFail } from './use-checkout-fail';

const settings = getPaymentMethodData(PAYMENT_METHOD_NAME, {});

const {
	icon_uri: iconURL,
	is_demo: isDEMO,
	title = __('2Checkout', 'woo-2checkout'),
	order_button_text: placeOrderButtonLabel = __(
		'Proceed to 2Checkout',
		'woo-2checkout'
	),
	description,
} = settings;

const label = decodeEntities(title);

/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
function Label(props) {
	const { PaymentMethodLabel } = props.components;
	return (
		<>
			<PaymentMethodLabel text={label} />
			&nbsp;
			<img
				alt={label}
				className="woo-2checkout-gateway-pay-image"
				src={iconURL}
			/>
		</>
	);
}

function Description() {
	if (isDEMO) {
		return (
			<>
				{description}
				<br />
				<strong>{__('DEMO MODE ENABLED.', 'woo-2checkout')}</strong>
				&nbsp;
				{__('Use a', 'woo-2checkout')}
				&nbsp;
				<a
					target="_blank"
					href="https://verifone.cloud/docs/2checkout/Documentation/09Test_ordering_system/01Test_payment_methods"
					rel="noreferrer"
				>
					{__('test payment cards', 'woo-2checkout')}
				</a>
			</>
		);
	}

	return description;
}

function canMakePayment() {
	return true; // always prepared to accept some .
}

/**
 * Site Content Component
 *
 * @param {*} props Props.
 */

function SiteContent(props) {
	// use On Checkout Fail.
	useCheckoutFail(props);

	return <Description />;
}

function EditorContent() {
	return <Description />;
}

/**
 * Woo 2Checkout payment method config object.
 */

const paymentMethod = {
	name: PAYMENT_METHOD_NAME,
	label: <Label />,
	content: <SiteContent />,
	edit: <EditorContent />,
	canMakePayment,
	placeOrderButtonLabel,
	icons: null,
	ariaLabel: label,
	supports: {
		features: settings.supports,
	},
};

registerPaymentMethod(paymentMethod);
